import { GrowFormFooter } from "@sinecycle/growcomponents";

const FormFooter = GrowFormFooter;

export { FormFooter };
